// extracted by mini-css-extract-plugin
export var deliberationsContainer = "deliberations-module--deliberations-container--9c7aa";